import { Component } from '../Component';

/**
 * TransformComponent - Position and rotation in world space
 * Uses isometric world coordinates (x, y, z)
 */
export class TransformComponent extends Component {
  public readonly type = 'transform';

  /** World X position (isometric grid) */
  public x: number;

  /** World Y position (isometric grid) */
  public y: number;

  /** World Z position (height/elevation) */
  public z: number;

  /** Rotation in radians */
  public rotation: number;

  /** Facing direction (0-7 for 8 directions) */
  public facing: number;

  constructor(data?: Partial<TransformComponent>) {
    super();
    this.x = data?.x ?? 0;
    this.y = data?.y ?? 0;
    this.z = data?.z ?? 0;
    this.rotation = data?.rotation ?? 0;
    this.facing = data?.facing ?? 0;
  }

  /**
   * Set position
   */
  public setPosition(x: number, y: number, z?: number): void {
    this.x = x;
    this.y = y;
    if (z !== undefined) this.z = z;
  }

  /**
   * Get distance to another transform
   */
  public distanceTo(other: TransformComponent): number {
    const dx = other.x - this.x;
    const dy = other.y - this.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  /**
   * Get direction to another transform (0-7 for 8 directions)
   */
  public directionTo(other: TransformComponent): number {
    const dx = other.x - this.x;
    const dy = other.y - this.y;
    const angle = Math.atan2(dy, dx);
    // Convert angle to 8-direction index
    return Math.round(((angle + Math.PI) / (2 * Math.PI)) * 8) % 8;
  }
}
